import { request } from '@/lib/api'

/**
 * Лид: действия карточки и заведение (тикет #101). Поля лида карточка читает механизмом
 * списков; здесь — операции, которых у списка нет: квалификация, отказ, конверсия.
 */

export interface LeadView {
  id: string
  title: string
  status: 'new' | 'in_progress' | 'qualified' | 'converted' | 'rejected'
  source: string
  contactName: string | null
  email: string | null
  phone: string | null
  companyName: string | null
  inn: string | null
  responsibleEmployeeId: string | null
  convertedDealId: string | null
  convertedCounterpartyId: string | null
  rejectionReason: string | null
  slaBreached: boolean
  utmSource?: string | null
  utmCampaign?: string | null
  /** Лид помечен дублем этого (слияние #101): закрыт, но не удалён — его метки нужны отчёту. */
  duplicateOfId?: string | null
  /** Срок первого отклика: часы SLA идут с приёма. */
  firstResponseDueAt?: string | null
  /** Первый отклик отмечен: часы остановлены. */
  firstResponseAt?: string | null
  createdAt?: string | null
}

export interface Conversion {
  lead: LeadView
  counterpartyId: string | null
  contactId: string | null
  deal: { id: string; number: string }
}

export interface NewLead {
  title: string
  source: string
  contactName?: string
  companyName?: string
  phone?: string
  email?: string
  inn?: string
}

export function fetchLead(id: string, signal?: AbortSignal): Promise<LeadView> {
  return request<LeadView>(`/sales/leads/${id}`, { signal })
}

export function createLead(body: NewLead): Promise<{ lead: LeadView; possibleDuplicates: LeadView[] }> {
  return request(`/sales/leads`, { method: 'POST', body })
}

export function qualifyLead(id: string): Promise<LeadView> {
  return request<LeadView>(`/sales/leads/${id}/qualify`, { method: 'POST' })
}

export function rejectLead(id: string, reason: string): Promise<LeadView> {
  return request<LeadView>(`/sales/leads/${id}/reject`, { method: 'POST', body: { reason } })
}

/** Контрагент, контакт и сделка одной транзакцией — всё или ничего. */
export function convertLead(id: string, funnelId: string): Promise<Conversion> {
  return request<Conversion>(`/sales/leads/${id}/convert`, { method: 'POST', body: { funnelId } })
}

/** Кандидаты в дубли: совпадение телефона, почты или ИНН (#101). */
export function fetchLeadDuplicates(id: string, signal?: AbortSignal): Promise<LeadView[]> {
  return request<LeadView[]>(`/sales/leads/${id}/duplicates`, { signal })
}

/**
 * Пометить **этот** лид дублем исходного. Дубль закрывается, но сохраняется: его метки —
 * часто той кампании, что вернула клиента; недостающие контакты переносятся в исходный.
 */
export function mergeLead(id: string, originalId: string): Promise<LeadView> {
  return request<LeadView>(`/sales/leads/${id}/merge`, { method: 'POST', body: { originalId } })
}

/** Отметить первый ответ клиенту — останавливает часы SLA. */
export function recordLeadResponse(id: string): Promise<LeadView> {
  return request<LeadView>(`/sales/leads/${id}/response`, { method: 'POST' })
}
